"use client";
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Checkbox } from "../../actions/selectionControls/Checkbox.js";
import { SelectionCardLoader, SelectionCardContent } from "./internal/SelectionCard.js";
import { InfoCard } from "./InfoCard.js";
import { StyledCardRecipe } from "./checkboxCard.css.js";
import { forwardRef } from "react";
import classNames from "classnames";
const CheckboxCard = forwardRef(function CheckboxCard2({ label, description, value, id, onChange, children, isLoading, validity, checkboxProps, cardStyle, ...props }, ref) {
  return jsx(InfoCard, { ref, ...props, className: classNames(StyledCardRecipe({
    disabled: props.disabled,
    cardStyle: cardStyle ?? "elevation"
  }), props.className), children: isLoading ? jsx(SelectionCardLoader, { type: "checkbox", density: props.density }) : jsxs(Fragment, { children: [jsx(Checkbox, { label, value, onChange, validity, id, disabled: props.disabled, ...checkboxProps }), jsx(SelectionCardContent, { description, value, density: props.density, children })] }) });
});
export {
  CheckboxCard
};
